  <div class="forgot-password-card">
    <div class="header-section">
      <h1 class="app-title">Change Password</h1>
      <button type="button" class="custom-close-btn" (click)="onCancel()" aria-label="Close">
        <img src="assets/icons/close-icon.svg" alt="close">
      </button>
    </div>
    
    <form class="forgot-password-form" [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
      <app-input-field
        label="Current Password"
        type="password"
        placeholder="Enter current password"
        icon="assets/icons/password-lock-icon.svg"
        [showPasswordToggle]="true"
        [required]="true"
        [hasError]="currentPasswordHasError"
        [errorMessage]="currentPasswordError"
        [value]="changePasswordForm.get('currentPassword')?.value || ''"
        (valueChange)="onCurrentPasswordChange($event)"
        (clearError)="onCurrentPasswordErrorClear()">
      </app-input-field>
      
      <app-input-field
        label="New Password"
        type="password"
        placeholder="Enter new password"
        icon="assets/icons/password-lock-icon.svg"
        [showPasswordToggle]="true"
        [showPasswordStrengthTooltip]="true"
        [required]="true"
        [hasError]="newPasswordHasError"
        [errorMessage]="newPasswordError"
        [value]="changePasswordForm.get('newPassword')?.value || ''"
        (valueChange)="onNewPasswordChange($event)"
        (clearError)="onNewPasswordErrorClear()">
      </app-input-field>
      
      <app-input-field
        label="Confirm New Password"
        type="password"
        placeholder="Confirm new password"
        icon="assets/icons/password-lock-icon.svg"
        [showPasswordToggle]="true"
        [required]="true"
        [hasError]="confirmPasswordHasError"
        [errorMessage]="confirmPasswordError"
        [value]="changePasswordForm.get('confirmPassword')?.value || ''"
        (valueChange)="onConfirmPasswordChange($event)"
        (clearError)="onConfirmPasswordErrorClear()">
      </app-input-field>
      
      <button type="submit" class="change-password-button" [disabled]="isLoading">
        <span *ngIf="!isLoading">Change Password</span>
        <span *ngIf="isLoading" class="spinner"></span>
      </button>
    </form>
    
  </div>